module.exports = __webpack_public_path__ + "static/i-am-and-always-will-be-a-titan-0ee8436dd59561b1fa633b9594ed2884.jpg";